import { defineStore } from 'pinia';
export const useCatSidebar = defineStore('catsidebar', {
    state: () => ({
        isSidebarVisible: false, // The state that controls the visibility of the sidebar
    }),
    actions: {
        toggleSidebar() {
            this.isSidebarVisible = !this.isSidebarVisible;
        },
        openSidebar() {
            this.isSidebarVisible = true;
        },
        handleCloseSidebar() {
            this.isSidebarVisible = false;
        },
    },
});
